import styled from 'styled-components';
export const CountdownElements = styled.ul`
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
	border-top-left-radius: 16px !important;
	border-top-right-radius: 16px !important;
	position: relative !important;
	height: 50px !important;
	gap: 16px !important;
	padding: 0 18px !important;
	text-align: center !important;
	font-size: 21px !important;
	font-weight: bold !important;
	color: white !important;
	background: var(--ticto-green) !important;
	margin: 0 !important;

	&.completed {
		background: var(--ticto-red) !important;
	}
	li {
		position: relative !important;
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
		float: none !important;
		list-style: none !important;
		background: var(--ticto-red) !important;
		border-radius: 08px !important;
		text-align: center !important;
		> h1,
		p {
			color: white !important;
		}

		p {
			font-size: 13px !important;
		}

		> .ticto-countdown-title {
			all: unset !important;
			display: block !important;
			width: 100% !important;
			margin: 0 !important;
			padding: 0 !important;
			font-family: 'Inter', Arial, Helvetica, sans-serif !important;
			font-size: 15px !important;
			font-weight: 700 !important;
			line-height: 1.2 !important;
			letter-spacing: normal !important;
			text-transform: none !important;
			text-indent: 0 !important;
			float: none !important;
			text-align: center !important;
			color: white !important;
		}

		&:not(:first-child) {
			&::before {
				content: ':' !important;
				position: absolute !important;
				font-size: 24px !important;
				left: -0.732px !important;
				top: 0.5px !important;
			}
		}
	}
`;
